import { render } from "./UsersView.vue?vue&type=template&id=fc8f9d32"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__